import { DiagnosisRegistrationStoreData } from '@/pages/demands/contexts/diagnosis-registration-store'

export interface MosaicAdapterProps {
  registerData: DiagnosisRegistrationStoreData['registerData']
  selectFilesData: DiagnosisRegistrationStoreData['selectFilesData']
}

export class MosaicAdapter {
  private registerData
  private selectFilesData

  constructor(props: MosaicAdapterProps) {
    this.registerData = props.registerData
    this.selectFilesData = props.selectFilesData
  }

  build() {
    if (this.registerData!.image_type !== 'mosaic') return

    return {
      image_gsd: this.selectFilesData!.mosaic!.results.gsd,
      image_name: this.selectFilesData!.mosaic!.input.at(0)!.name,
      coord_x: this.selectFilesData!.mosaic!.results.coord_x,
      coord_y: this.selectFilesData!.mosaic!.results.coord_y,
      px_res: this.selectFilesData!.mosaic!.results.px_res,
    }
  }

  makeFileReference(mosaicId?: string) {
    if (this.registerData!.image_type !== 'mosaic') return

    const input = this.selectFilesData!.mosaic!.input!.at(0)!

    return {
      file: input,
      type: 'mosaic',
      inputType: 'mosaic',
      resumable: true,
      originalFilename: input?.name,
      bucketFilename: `${mosaicId}.tif`,
    } as const
  }
}
